'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.loadCompactMenus = loadCompactMenus;
exports.default = locationsRootSaga;

var _effects = require('redux-saga/effects');

var _LocationsActions = require('../actions/LocationsActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(loadCompactMenus),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(locationsRootSaga);

var signedInstanceSelector = function signedInstanceSelector(state) {
    return state.wixInstance.value;
};

function loadCompactMenus(sagaParams, _ref) {
    var _ref$payload = _ref.payload,
        orgId = _ref$payload.orgId,
        locale = _ref$payload.locale,
        locations = _ref$payload.locations;
    var fetch, signedInstance, serverlessUrl, platform, locationsIds, compactMenusUrl, compactMenusList;
    return _regenerator2.default.wrap(function loadCompactMenus$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    fetch = sagaParams.fetch;
                    _context.next = 3;
                    return (0, _effects.select)(signedInstanceSelector);

                case 3:
                    signedInstance = _context.sent;
                    serverlessUrl = 'https://apps.wixrestaurants.com/wix/_serverless/dashboard-middleware-api/' + orgId;
                    platform = typeof Wix !== 'undefined' && Wix.Utils.getDeviceType() === 'mobile' ? 'mobileweb' : 'web';
                    locationsIds = locations.map(function (location) {
                        return location.locationId;
                    });
                    compactMenusUrl = serverlessUrl + '/compactMenus?locale=' + locale + '&locationIds=' + locationsIds.join(',') + '&platform=' + platform;
                    _context.next = 10;
                    return (0, _effects.call)(function () {
                        return fetch(compactMenusUrl, {
                            headers: {
                                Authorization: signedInstance
                            }
                        }).then(function (r) {
                            return r.json();
                        });
                    });

                case 10:
                    compactMenusList = _context.sent;
                    _context.next = 13;
                    return (0, _effects.put)(_LocationsActions.actions.setCompactMenus({ compactMenusList: compactMenusList }));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function locationsRootSaga(sagaParams) {
    return _regenerator2.default.wrap(function locationsRootSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeEvery)(_LocationsActions.types.LOAD_COMPACT_MENUS, loadCompactMenus.bind(null, sagaParams));

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}